export interface Airline {
  /** 2-character IATA code, uppercase. Canonical identifier. */
  iata: string;
  /** 3-character ICAO code where known. */
  icao?: string;
  /** Marketing name (e.g. "United Airlines"). */
  name: string;
  /** ISO country/region of the carrier's home base. */
  country: string;
}

// Generated by apps/api/scripts/generateIataData.ts from the OpenFlights
// dataset (active airlines with IATA codes only). Do not hand-edit — re-run
// the script to regenerate.
export const AIRLINES: readonly Airline[] = [
  { iata: '01', name: 'Bobb Air Freight', country: 'Germany' },
  { iata: '0B', icao: 'JOR', name: 'Blue Air', country: 'Romania' },
  { iata: '0D', icao: 'DWT', name: 'Darwin Airline', country: 'Switzerland' },
  { iata: '0G', icao: 'GA0', name: 'Global Airlines', country: 'Argentina' },
  { iata: '0M', icao: '0MM', name: 'All America MX', country: 'Mexico' },
  { iata: '0P', icao: 'PYB', name: 'All America BOPY', country: 'Paraguay' },
  { iata: '0X', icao: 'CX0', name: 'Copenhagen Express', country: 'Denmark' },
  { iata: '0Y', icao: '7ZC', name: 'All America CO', country: 'Colombia' },
  { iata: '11', name: 'TUIfly (X3)', country: 'Germany' },
  { iata: '12', icao: 'N12', name: '12 North', country: 'India' },
  { iata: '13', icao: 'EAV', name: 'Eastern Atlantic Virtual Airlines', country: 'United States' },
  { iata: '1B', name: 'Abacus International', country: 'Singapore' },
  { iata: '1C', icao: '1CH', name: 'OneChina', country: 'China' },
  { iata: '1E', icao: 'RGG', name: 'TransRussiaAirlines', country: 'Russia' },
  { iata: '1F', icao: 'CIF', name: 'CB Airways UK ( Interliging Flights )', country: 'United Kingdom' },
  { iata: '1I', icao: 'EJA', name: 'NetJets', country: 'United States' },
  { iata: '1K', icao: 'BG1', name: 'BudgetAir', country: 'Germany' },
  { iata: '1R', icao: 'R1R', name: 'All America CL', country: 'Chile' },
  { iata: '1T', icao: 'RNX', name: '1Time Airline', country: 'South Africa' },
  { iata: '1X', name: 'Island Express Air', country: 'Canada' },
  { iata: '1Y', icao: 'A9B', name: 'All America BR', country: 'Brazil' },
  { iata: '20', icao: 'RNE', name: 'Air Salone', country: 'Sierra Leone' },
  { iata: '24', name: 'Euro Jet', country: 'Germany' },
  { iata: '2A', name: 'Deutsche Bahn', country: 'Germany' },
  { iata: '2B', icao: 'ARD', name: 'Aerocondor', country: 'Portugal' },
  { iata: '2D', name: 'Aero VIP (2D)', country: 'Portugal' },
  { iata: '2F', icao: 'FTA', name: 'Frontier Flying Service', country: 'United States' },
  { iata: '2I', name: 'Star Peru (2I)', country: 'Peru' },
  { iata: '2J', icao: 'VBW', name: 'Air Burkina', country: 'Burkina Faso' },
  { iata: '2K', icao: 'GLG', name: 'Aerolineas Galapagos (Aerogal)', country: 'Ecuador' },
  { iata: '2L', icao: 'OAW', name: 'Helvetic Airways', country: 'Switzerland' },
  { iata: '2M', icao: 'MDV', name: 'Moldavian Airlines', country: 'Moldova' },
  { iata: '2N', icao: 'NTJ', name: 'NextJet', country: 'Sweden' },
  { iata: '2O', name: 'Air Salone', country: 'Sierra Leone' },
  { iata: '2P', icao: 'GAP', name: 'Air Philippines', country: 'Philippines' },
  { iata: '2Q', icao: 'SNC', name: 'Air Cargo Carriers', country: 'United States' },
  { iata: '2R', icao: 'M7A', name: 'All America AR', country: 'Argentina' },
  { iata: '2S', name: 'Air Carnival', country: 'India' },
  { iata: '2T', icao: 'HAM', name: 'Haiti Ambassador Airlines', country: 'Haiti' },
  { iata: '2U', icao: 'GIP', name: 'Air Guinee Express', country: 'Guinea' },
  { iata: '2W', icao: 'WLC', name: 'Welcome Air', country: 'Austria' },
  { iata: '2X', icao: '2K2', name: 'Regionalia Uruguay', country: 'Uruguay' },
  { iata: '3B', name: 'JobAir', country: 'Czech Republic' },
  { iata: '3E', name: 'Air Choice One', country: 'United States' },
  { iata: '3F', icao: '3FF', name: 'Fly Colombia ( Interliging Flights )', country: 'Colombia' },
  { iata: '3G', icao: 'AYZ', name: 'Atlant-Soyuz Airlines', country: 'Russia' },
  { iata: '3I', name: 'Air Comet Chile', country: 'Chile' },
  { iata: '3K', icao: 'JSA', name: 'Jetstar Asia Airways', country: 'Singapore' },
  { iata: '3L', icao: 'ISK', name: 'Intersky', country: 'Austria' },
  { iata: '3M', name: 'Silver Airways (3M)', country: 'United States' },
  { iata: '3O', name: 'Air Arabia Maroc', country: 'Morocco' },
  { iata: '3P', icao: 'TNM', name: 'Tiara Air', country: 'Aruba' },
  { iata: '3Q', icao: 'CYH', name: 'Yunnan Airlines', country: 'China' },
  { iata: '3R', icao: 'GAI', name: 'Moskovia Airlines', country: 'Russia' },
  { iata: '3S', name: 'Air Antilles Express', country: 'Guadeloupe' },
  { iata: '3T', icao: 'URN', name: 'Turan Air', country: 'Azerbaijan' },
  { iata: '3U', icao: 'CSC', name: 'Sichuan Airlines', country: 'China' },
  { iata: '3W', name: 'Malawian Airlines', country: 'Malawi' },
  { iata: '47', icao: 'VVN', name: '88', country: 'Cyprus' },
  { iata: '4A', icao: 'AKL', name: 'Air Kiribati', country: 'Kiribati' },
  { iata: '4B', icao: 'BTQ', name: 'Boutique Air (Priv)', country: 'United States' },
  { iata: '4C', icao: 'ARE', name: 'Aires', country: 'S.A.' },
  { iata: '4D', icao: 'ASD', name: 'Air Sinai', country: 'Egypt' },
  { iata: '4G', icao: 'GZP', name: 'Gazpromavia', country: 'Russia' },
  { iata: '4H', icao: 'UBD', name: 'United Airways', country: 'Bangladesh' },
  { iata: '4K', icao: 'AAS', name: 'Askari Aviation', country: 'Pakistan' },
  { iata: '4L', icao: 'MJX', name: 'Euroline', country: 'Georgia' },
  { iata: '4M', icao: 'DSM', name: 'LAN Argentina', country: 'Argentina' },
  { iata: '4N', icao: 'ANT', name: 'Air North Charter - Canada', country: 'Canada' },
  { iata: '4O', name: 'Interjet (ABC Aerolineas)', country: 'Mexico' },
  { iata: '4P', name: 'Business Aviation', country: 'Congo (Kinshasa)' },
  { iata: '4Q', name: 'Safi Airlines', country: 'Afghanistan' },
  { iata: '4R', icao: 'HHI', name: 'Hamburg International', country: 'Germany' },
  { iata: '4S', icao: 'VI4', name: 'Vuola Italia', country: 'Italy' },
  { iata: '4T', icao: 'BHP', name: 'Belair Airlines', country: 'Switzerland' },
  { iata: '4U', icao: 'GWI', name: 'Germanwings', country: 'Germany' },
  { iata: '4X', name: 'Red Jet Mexico', country: 'Mexico' },
  { iata: '4Z', name: 'Airlink (SAA)', country: 'South Africa' },
  { iata: '5B', icao: 'BSX', name: 'Bassaka airlines', country: 'Cambodia' },
  { iata: '5C', icao: 'ICL', name: 'CAL Cargo Air Lines', country: 'Israel' },
  { iata: '5D', icao: 'SLI', name: 'Aerolitoral', country: 'Mexico' },
  { iata: '5E', name: 'SGA Airlines', country: 'Thailand' },
  { iata: '5G', icao: 'SSV', name: 'Skyservice Airlines', country: 'Canada' },
  { iata: '5H', icao: 'FFV', name: 'Fly540', country: 'Kenya' },
  { iata: '5J', icao: 'CEB', name: 'Cebu Pacific', country: 'Philippines' },
  { iata: '5K', name: 'Hi Fly (5K)', country: 'Portugal' },
  { iata: '5L', icao: 'RSU', name: 'Aerosur', country: 'Bolivia' },
  { iata: '5M', icao: 'SIB', name: 'Sibaviatrans', country: 'Russia' },
  { iata: '5N', icao: 'AUL', name: 'Aeroflot-Nord', country: 'Russia' },
  { iata: '5P', name: 'Pal airlines', country: 'Chile' },
  { iata: '5Q', name: 'BQB Lineas Aereas', country: 'Uruguay' },
  { iata: '5T', icao: 'MPE', name: 'Canadian North', country: 'Canada' },
  { iata: '5W', icao: 'AEU', name: 'Astraeus', country: 'United Kingdom' },
  { iata: '5Y', icao: 'GTI', name: 'Atlas Air', country: 'United States' },
  { iata: '5Z', icao: 'VVC', name: 'VivaColombia', country: 'Colombia' },
  { iata: '69', name: 'Royal European Airlines', country: 'United Kingdom' },
  { iata: '6A', icao: 'CHP', name: 'Consorcio Aviaxsa', country: 'Mexico' },
  { iata: '6B', icao: 'BLX', name: 'TUIfly Nordic', country: 'Sweden' },
  { iata: '6C', icao: '6CC', name: 'Vuela Cuba', country: 'Cuba' },
  { iata: '6D', name: 'Pelita', country: 'Indonesia' },
  { iata: '6E', icao: 'IGO', name: 'IndiGo Airlines', country: 'India' },
  { iata: '6F', icao: 'MKD', name: 'MAT Airways', country: 'Macedonia' },
  { iata: '6G', icao: 'AWW', name: 'Air Wales', country: 'United Kingdom' },
  { iata: '6H', icao: 'ISR', name: 'Israir', country: 'Israel' },
  { iata: '6I', name: 'Fly 6ix', country: 'Sierra Leone' },
  { iata: '6J', icao: 'SNJ', name: 'Skynet Asia Airways', country: 'Japan' },
  { iata: '6K', icao: 'RIT', name: 'Asian Spirit', country: 'Philippines' },
  { iata: '6P', name: 'Gryphon Airlines', country: 'United States' },
  { iata: '6R', icao: 'DRU', name: 'Alrosa Mirny Air Enterprise', country: 'Russia' },
  { iata: '6T', name: 'Air Mandalay', country: 'Burma' },
  { iata: '6U', name: 'Air Cargo Germany', country: 'Germany' },
  { iata: '6V', icao: 'CZV', name: 'Via Conectia Airlines', country: 'Uruguay' },
  { iata: '6W', icao: 'SOV', name: 'Saratov Aviation Division', country: 'Russia' },
  { iata: '6Y', name: 'SmartLynx Airlines', country: 'Latvia' },
  { iata: '76', icao: 'SJS', name: 'Southjet', country: 'United States' },
  { iata: '77', icao: 'ZCS', name: 'Southjet connect', country: 'United States' },
  { iata: '78', icao: 'XAN', name: 'Southjet cargo', country: 'United States' },
  { iata: '7B', icao: 'KJC', name: 'Krasnojarsky Airlines', country: 'Russia' },
  { iata: '7C', icao: 'JJA', name: 'Jeju Air', country: 'Republic of Korea' },
  { iata: '7E', icao: 'AWU', name: 'Aeroline GmbH', country: 'Germany' },
  { iata: '7F', icao: 'FAB', name: 'First Air', country: 'Canada' },
  { iata: '7G', icao: 'SFJ', name: 'Star Flyer', country: 'Japan' },
  { iata: '7H', icao: 'ERR', name: 'Era Alaska', country: 'United States' },
  { iata: '7I', name: 'Insel Air (7I/INC) (Priv)', country: 'Netherlands Antilles' },
  { iata: '7J', name: 'Tajik Air', country: 'Tajikistan' },
  { iata: '7K', icao: 'KGL', name: 'Kogalymavia Air Company', country: 'Russia' },
  { iata: '7L', icao: 'ERO', name: 'Sun D\'Or', country: 'Israel' },
  { iata: '7M', icao: 'ZTF', name: 'Mongolian International Air Lines', country: 'Mongolia' },
  { iata: '7O', icao: '7KK', name: 'All Colombia', country: 'Colombia' },
  { iata: '7P', icao: 'BTV', name: 'Metro Batavia', country: 'Indonesia' },
  { iata: '7Q', name: 'Pan Am World Airways Dominicana', country: 'Dominican Republic' },
  { iata: '7R', icao: 'SJM', name: 'Svyaz Rossiya', country: 'Russia' },
  { iata: '7T', icao: 'AGV', name: 'Air Glaciers', country: 'Switzerland' },
  { iata: '7W', name: 'Wayraper', country: 'Peru' },
  { iata: '7Y', name: 'Med Airways', country: 'Lebanon' },
  { iata: '7Z', name: 'Halcyonair', country: 'Cape Verde' },
  { iata: '88', icao: '8K8', name: 'All Australia', country: 'Australia' },
  { iata: '8A', icao: 'BMM', name: 'Atlas Blue', country: 'Morocco' },
  { iata: '8B', icao: 'BCC', name: 'BusinessAir', country: 'Thailand' },
  { iata: '8D', name: 'Astair', country: 'Russian Federation' },
  { iata: '8E', icao: 'BRG', name: 'Bering Air', country: 'United States' },
  { iata: '8F', icao: 'STP', name: 'STP Airways', country: 'Sao Tome and Principe' },
  { iata: '8H', icao: 'HFR', name: 'Heli France', country: 'France' },
  { iata: '8I', name: 'Myway Airlines', country: 'Italy' },
  { iata: '8J', icao: 'JFU', name: 'Jet4You', country: 'Morocco' },
  { iata: '8K', icao: 'K88', name: 'Voestar', country: 'Brazil' },
  { iata: '8L', icao: 'CGP', name: 'Cargo Plus Aviation', country: 'United Arab Emirates' },
  { iata: '8M', icao: 'MXL', name: 'Maxair', country: 'Sweden' },
  { iata: '8N', icao: 'NKF', name: 'Barents AirLink', country: 'Sweden' },
  { iata: '8O', name: 'West Coast Air', country: 'Canada' },
  { iata: '8P', icao: 'PCO', name: 'Pacific Coastal Airline', country: 'Canada' },
  { iata: '8Q', icao: 'OHY', name: 'Onur Air', country: 'Turkey' },
  { iata: '8R', icao: 'TIB', name: 'TRIP Linhas A', country: 'Brazil' },
  { iata: '8T', name: 'Air Tindi', country: 'Canadian Territories' },
  { iata: '8U', icao: 'AAW', name: 'Afriqiyah Airways', country: 'Libya' },
  { iata: '8V', icao: 'ACP', name: 'Astral Aviation', country: 'Kenya' },
  { iata: '8Z', icao: 'WVL', name: 'Wizz Air Hungary', country: 'Bulgaria' },
  { iata: '99', name: 'Ciao Air', country: 'Italy' },
  { iata: '9A', icao: '99F', name: 'All Africa', country: 'South Africa' },
  { iata: '9C', name: 'China SSS', country: 'China' },
  { iata: '9E', icao: 'FLG', name: 'Pinnacle Airlines', country: 'United States' },
  { iata: '9H', name: 'MDLR Airlines', country: 'India' },
  { iata: '9I', icao: 'INE', name: 'International Europe', country: 'Spain' },
  { iata: '9J', icao: 'CR1', name: 'Regionalia Chile', country: 'Chile' },
  { iata: '9K', icao: 'KAP', name: 'Cape Air', country: 'United States' },
  { iata: '9L', icao: 'CJC', name: 'Colgan Air', country: 'United States' },
  { iata: '9N', icao: 'N78', name: 'Regional Air Iceland', country: 'Iceland' },
  { iata: '9Q', icao: 'PBA', name: 'PB Air', country: 'Thailand' },
  { iata: '9R', icao: 'NSE', name: 'SATENA', country: 'Colombia' },
  { iata: '9S', icao: 'CQH', name: 'Spring Airlines', country: 'China' },
  { iata: '9T', icao: 'ABS', name: 'Transwest Air', country: 'Canada' },
  { iata: '9U', icao: 'MLD', name: 'Air Moldova', country: 'Moldova' },
  { iata: '9V', icao: 'VC9', name: 'Volotea Costa Rica', country: 'Costa Rica' },
  { iata: '9W', icao: 'JAI', name: 'Jet Airways', country: 'India' },
  { iata: '9X', icao: '9XX', name: 'Regionalia Venezuela', country: 'Venezuela' },
  { iata: '9Y', icao: 'KZK', name: 'Air Kazakhstan', country: 'Kazakhstan' },
  { iata: 'A1', icao: 'A1F', name: 'Atifly', country: 'United States' },
  { iata: 'A2', icao: 'AL2', name: 'All America', country: 'United States' },
  { iata: 'A3', icao: 'AEE', name: 'Aegean Airlines', country: 'Greece' },
  { iata: 'A4', icao: 'SWD', name: 'Southern Winds Airlines', country: 'Argentina' },
  { iata: 'A5', icao: 'RLA', name: 'Airlinair', country: 'France' },
  { iata: 'A6', name: 'Air Alps Aviation (A6)', country: 'Austria' },
  { iata: 'A7', icao: 'MPD', name: 'Air Plus Comet', country: 'Spain' },
  { iata: 'A9', icao: 'TGZ', name: 'Georgian Airways', country: 'Georgia' },
  { iata: 'AA', icao: 'AAL', name: 'American Airlines', country: 'United States' },
  { iata: 'AB', icao: 'BER', name: 'Air Berlin', country: 'Germany' },
  { iata: 'AC', icao: 'ACA', name: 'Air Canada', country: 'Canada' },
  { iata: 'AD', icao: 'AZU', name: 'Azul', country: 'Brazil' },
  { iata: 'AE', icao: 'MDA', name: 'Mandarin Airlines', country: 'Taiwan' },
  { iata: 'AF', icao: 'AFR', name: 'Air France', country: 'France' },
  { iata: 'AG', icao: 'SSA', name: 'All America US', country: 'United States' },
  { iata: 'AH', icao: 'DAH', name: 'Air Algerie', country: 'Algeria' },
  { iata: 'AI', icao: 'AIC', name: 'Air India Limited', country: 'India' },
  { iata: 'AJ', icao: 'NIG', name: 'Aero Contractors', country: 'Nigeria' },
  { iata: 'AK', icao: 'AXM', name: 'AirAsia', country: 'Malaysia' },
  { iata: 'AL', icao: 'SYX', name: 'Skywalk Airlines', country: 'United States' },
  { iata: 'AM', icao: 'AMX', name: 'AeroMéxico', country: 'Mexico' },
  { iata: 'AN', icao: 'AAA', name: 'Ansett Australia', country: 'Australia' },
  { iata: 'AO', name: 'Avianova (Russia)', country: 'Russia' },
  { iata: 'AP', icao: 'ADH', name: 'Air One', country: 'Italy' },
  { iata: 'AQ', icao: 'AAH', name: 'Aloha Airlines', country: 'United States' },
  { iata: 'AR', icao: 'ARG', name: 'Aerolineas Argentinas', country: 'Argentina' },
  { iata: 'AS', icao: 'ASA', name: 'Alaska Airlines', country: 'ALASKA' },
  { iata: 'AT', icao: 'RAM', name: 'Royal Air Maroc', country: 'Morocco' },
  { iata: 'AU', icao: 'AUT', name: 'Austral Lineas Aereas', country: 'Argentina' },
  { iata: 'AV', icao: 'AVA', name: 'Avianca - Aerovias Nacionales de Colombia', country: 'AVIANCA' },
  { iata: 'AW', icao: 'AWM', name: 'Asian Wings Airways', country: 'Burma' },
  { iata: 'AX', icao: 'LOF', name: 'Trans States Airlines', country: 'United States' },
  { iata: 'AY', icao: 'FIN', name: 'Finnair', country: 'Finland' },
  { iata: 'AZ', icao: 'AZA', name: 'Alitalia', country: 'Italy' },
  { iata: 'B0', icao: '666', name: 'Aws express', country: 'United States' },
  { iata: 'B1', icao: 'BA1', name: 'Baltic Air lines', country: 'Latvia' },
  { iata: 'B2', icao: 'BRU', name: 'Belavia Belarusian Airlines', country: 'Belarus' },
  { iata: 'B3', icao: 'BLV', name: 'Bellview Airlines', country: 'Nigeria' },
  { iata: 'B4', icao: 'GSM', name: 'Flyglobespan', country: 'United Kingdom' },
  { iata: 'B5', icao: 'FLT', name: 'Flightline', country: 'United Kingdom' },
  { iata: 'B6', icao: 'JBU', name: 'JetBlue Airways', country: 'United States' },
  { iata: 'B7', icao: 'UIA', name: 'Uni Air', country: 'Taiwan' },
  { iata: 'B8', icao: 'ERT', name: 'Eritrean Airlines', country: 'Eritrea' },
  { iata: 'B9', icao: 'BGD', name: 'Air Bangladesh', country: 'Bangladesh' },
  { iata: 'BA', icao: 'BAW', name: 'British Airways', country: 'United Kingdom' },
  { iata: 'BB', icao: 'SBS', name: 'Seaborne Airlines', country: 'United States' },
  { iata: 'BC', icao: 'SKY', name: 'Skymark Airlines', country: 'Japan' },
  { iata: 'BD', icao: 'BMA', name: 'bmi', country: 'United Kingdom' },
  { iata: 'BE', icao: 'BEE', name: 'Flybe', country: 'United Kingdom' },
  { iata: 'BF', icao: 'RSR', name: 'Aero-Service', country: 'Republic of the Congo' },
  { iata: 'BG', icao: 'BBC', name: 'Biman Bangladesh Airlines', country: 'Bangladesh' },
  { iata: 'BH', name: 'Hawkair', country: 'Canada' },
  { iata: 'BI', icao: 'RBA', name: 'Royal Brunei Airlines', country: 'Brunei' },
  { iata: 'BJ', icao: 'LBT', name: 'Nouvel Air Tunisie', country: 'Tunisia' },
  { iata: 'BK', icao: 'PDC', name: 'Potomac Air', country: 'United States' },
  { iata: 'BL', icao: 'PIC', name: 'Jetstar Pacific', country: 'Vietnam' },
  { iata: 'BM', name: 'Air Sicilia', country: 'Italy' },
  { iata: 'BN', icao: 'HZA', name: 'Horizon Airlines', country: 'Australia' },
  { iata: 'BP', icao: 'BOT', name: 'Air Botswana', country: 'Botswana' },
  { iata: 'BQ', icao: 'BQB', name: 'Buquebus Líneas Aéreas', country: 'Uruguay' },
  { iata: 'BR', icao: 'EVA', name: 'EVA Air', country: 'Taiwan' },
  { iata: 'BS', icao: 'BIH', name: 'British International Helicopters', country: 'United Kingdom' },
  { iata: 'BT', icao: 'BTI', name: 'Air Baltic', country: 'Latvia' },
  { iata: 'BU', icao: 'BUU', name: 'Baikotovitchestrian Airlines', country: 'American Samoa' },
  { iata: 'BV', icao: 'BPA', name: 'Blue Panorama Airlines', country: 'Italy' },
  { iata: 'BW', icao: 'BWA', name: 'Caribbean Airlines', country: 'Trinidad and Tobago' },
  { iata: 'BX', icao: 'ABL', name: 'Air Busan', country: 'Republic of Korea' },
  { iata: 'BY', icao: 'TOM', name: 'Thomsonfly', country: 'United Kingdom' },
  { iata: 'BZ', icao: 'BSA', name: 'Black Stallion Airways', country: 'United States' },
  { iata: 'C0', icao: 'CLW', name: 'Centralwings', country: 'Poland' },
  { iata: 'C1', icao: 'CA1', name: 'CanXpress', country: 'Canada' },
  { iata: 'C2', icao: 'CAP', name: 'CanXplorer', country: 'Canada' },
  { iata: 'C3', icao: 'KIS', name: 'Contact Air', country: 'Germany' },
  { iata: 'C4', icao: 'LIX', name: 'LionXpress', country: 'Cameroon' },
  { iata: 'C5', icao: 'UCA', name: 'CommutAir', country: 'United States' },
  { iata: 'C7', icao: 'CR7', name: 'Sky Wing Pacific', country: 'South Korea' },
  { iata: 'C9', icao: 'RUS', name: 'Cirrus Airlines', country: 'Germany' },
  { iata: 'CA', icao: 'CCA', name: 'Air China', country: 'China' },
  { iata: 'CB', icao: 'CCC', name: 'CCML Airlines', country: 'Colombia' },
  { iata: 'CC', icao: 'ABD', name: 'Air Atlanta Icelandic', country: 'Iceland' },
  { iata: 'CD', name: 'Air India Regional', country: 'India' },
  { iata: 'CE', icao: 'NTW', name: 'Nationwide Airlines', country: 'South Africa' },
  { iata: 'CF', icao: 'SDR', name: 'City Airline', country: 'Sweden' },
  { iata: 'CG', icao: 'TOK', name: 'Airlines PNG', country: 'Papua New Guinea' },
  { iata: 'CH', icao: 'BMJ', name: 'Bemidji Airlines', country: 'United States' },
  { iata: 'CI', icao: 'CAL', name: 'China Airlines', country: 'Taiwan' },
  { iata: 'CJ', icao: 'CFE', name: 'BA CityFlyer', country: 'United Kingdom' },
  { iata: 'CL', icao: 'CLH', name: 'Lufthansa CityLine', country: 'Germany' },
  { iata: 'CM', icao: 'CMP', name: 'Copa Airlines', country: 'Panama' },
  { iata: 'CN', icao: 'YCP', name: 'Canadian National Airways', country: 'Canada' },
  { iata: 'CO', icao: 'COA', name: 'Continental Airlines', country: 'United States' },
  { iata: 'CP', icao: 'CDN', name: 'Canadian Airlines', country: 'Canada' },
  { iata: 'CQ', icao: 'KOL', name: 'SOCHI AIR', country: 'Russia' },
  { iata: 'CS', icao: 'CMI', name: 'Continental Micronesia', country: 'United States' },
  { iata: 'CT', name: 'Alitalia Cityliner', country: 'Italy' },
  { iata: 'CU', icao: 'CUB', name: 'Cubana de Aviación', country: 'Cuba' },
  { iata: 'CV', icao: 'CVA', name: 'Air Chathams', country: 'New Zealand' },
  { iata: 'CW', icao: 'CWM', name: 'Air Marshall Islands', country: 'Marshall Islands' },
  { iata: 'CX', icao: 'CPA', name: 'Cathay Pacific', country: 'Hong Kong SAR of China' },
  { iata: 'CY', icao: 'CYP', name: 'Cyprus Airways', country: 'Cyprus' },
  { iata: 'CZ', icao: 'CSN', name: 'China Southern Airlines', country: 'China' },
  { iata: 'D1', icao: 'MDO', name: 'Domenican Airlines', country: 'Dominican Republic' },
  { iata: 'D2', name: 'Severstal Air Company', country: 'Russia' },
  { iata: 'D3', icao: 'DAO', name: 'Daallo Airlines', country: 'Djibouti' },
  { iata: 'D6', icao: 'ILN', name: 'Interair South Africa', country: 'South Africa' },
  { iata: 'D7', icao: 'XAX', name: 'AirAsia X', country: 'Malaysia' },
  { iata: 'D8', icao: 'DJB', name: 'Djibouti Airlines', country: 'Djibouti' },
  { iata: 'D9', icao: 'DNV', name: 'Aeroflot-Don', country: 'Russia' },
  { iata: 'DA', name: 'Dana Air', country: 'Nigeria' },
  { iata: 'DB', icao: 'BZH', name: 'Brit Air', country: 'France' },
  { iata: 'DC', icao: 'GAO', name: 'Golden Air', country: 'Sweden' },
  { iata: 'DD', icao: 'NOK', name: 'Nok Air', country: 'Thailand' },
  { iata: 'DE', icao: 'CFG', name: 'Condor Flugdienst', country: 'Germany' },
  { iata: 'DF', icao: 'MJG', name: 'Michael Airlines', country: 'Puerto Rico' },
  { iata: 'DG', icao: 'SRQ', name: 'South East Asian Airlines', country: 'Philippines' },
  { iata: 'DH', icao: 'DSY', name: 'Dennis Sky', country: 'Israel' },
  { iata: 'DI', icao: 'BAG', name: 'dba', country: 'Germany' },
  { iata: 'DK', icao: 'ELA', name: 'Eastland Air', country: 'Australia' },
  { iata: 'DL', icao: 'DAL', name: 'Delta Air Lines', country: 'United States' },
  { iata: 'DM', name: 'Maersk', country: 'Denmark' },
  { iata: 'DN', icao: 'SGG', name: 'Senegal Airlines', country: 'Senegal' },
  { iata: 'DO', icao: 'DOA', name: 'Dominicana de Aviaci', country: 'Dominican Republic' },
  { iata: 'DP', icao: 'FCA', name: 'First Choice Airways', country: 'United Kingdom' },
  { iata: 'DQ', name: 'Coastal Air', country: 'United States' },
  { iata: 'DR', icao: 'BIE', name: 'Air Mediterranee', country: 'France' },
  { iata: 'DS', name: 'EasyJet (DS)', country: 'Switzerland' },
  { iata: 'DT', icao: 'DTA', name: 'TAAG Angola Airlines', country: 'Angola' },
  { iata: 'DU', icao: 'NLH', name: 'Norwegian Long Haul AS', country: 'Norway' },
  { iata: 'DV', icao: 'VSV', name: 'Scat Air', country: 'Kazakhstan' },
  { iata: 'DX', icao: 'DTR', name: 'DAT Danish Air Transport', country: 'Denmark' },
  { iata: 'DY', icao: 'NAX', name: 'Norwegian Air Shuttle', country: 'Norway' },
  { iata: 'DZ', name: 'Starline.kz', country: 'Kazakhstan' },
  { iata: 'E1', icao: 'ES2', name: 'Usa Sky Cargo', country: 'United States' },
  { iata: 'E2', name: 'Eagle Atlantic Airlines', country: 'Ghana' },
  { iata: 'E3', icao: 'DMO', name: 'Domodedovo Airlines', country: 'Russia' },
  { iata: 'E4', icao: 'GIE', name: 'Elysian Airlines', country: 'Cameroon' },
  { iata: 'E5', icao: 'RBG', name: 'Air Arabia Egypt', country: 'Egypt' },
  { iata: 'E8', icao: 'GTA', name: 'City Airways', country: 'Thailand' },
  { iata: 'E9', name: 'Compagnie Africaine d\\\\\'Aviation', country: 'Congo (Kinshasa)' },
  { iata: 'EA', icao: 'EAL', name: 'European Air Express', country: 'Germany' },
  { iata: 'EC', icao: 'TWN', name: 'Avialeasing Aviation Company', country: 'Uzbekistan' },
  { iata: 'ED', icao: 'ABQ', name: 'Airblue', country: 'Pakistan' },
  { iata: 'EE', name: 'Nordica', country: 'Estonia' },
  { iata: 'EF', icao: 'EFA', name: 'Far Eastern Air Transport', country: 'Taiwan' },
  { iata: 'EG', icao: 'JAA', name: 'Japan Asia Airways', country: 'Japan' },
  { iata: 'EI', icao: 'EIN', name: 'Aer Lingus', country: 'Ireland' },
  { iata: 'EJ', icao: 'NEA', name: 'New England Airlines', country: 'United States' },
  { iata: 'EK', icao: 'UAE', name: 'Emirates', country: 'United Arab Emirates' },
  { iata: 'EL', icao: 'ANK', name: 'Air Nippon', country: 'Japan' },
  { iata: 'EM', icao: 'AEB', name: 'Aero Benin', country: 'Benin' },
  { iata: 'EN', icao: 'DLA', name: 'Air Dolomiti', country: 'Italy' },
  { iata: 'EO', icao: 'LHN', name: 'Express One International', country: 'United States' },
  { iata: 'EP', icao: 'IRC', name: 'Iran Aseman Airlines', country: 'Iran' },
  { iata: 'EQ', icao: 'TAE', name: 'TAME', country: 'Ecuador' },
  { iata: 'ER', icao: 'RWW', name: 'Fly Europa', country: 'Spain' },
  { iata: 'ES', icao: 'EUV', name: 'EuropeSky', country: 'Germany' },
  { iata: 'ET', icao: 'ETH', name: 'Ethiopian Airlines', country: 'Ethiopia' },
  { iata: 'EU', icao: 'EEA', name: 'Empresa Ecuatoriana De Aviacion', country: 'Ecuador' },
  { iata: 'EV', icao: 'ASQ', name: 'Atlantic Southeast Airlines', country: 'United States' },
  { iata: 'EW', icao: 'EWG', name: 'Eurowings', country: 'Germany' },
  { iata: 'EX', icao: 'EU9', name: 'Europe Jet', country: 'France' },
  { iata: 'EY', icao: 'ETD', name: 'Etihad Airways', country: 'United Arab Emirates' },
  { iata: 'EZ', icao: 'EIA', name: 'Evergreen International Airlines', country: 'United States' },
  { iata: 'F1', icao: 'FBL', name: 'Fly Brasil', country: 'Brazil' },
  { iata: 'F5', icao: 'FI5', name: 'Fly One', country: 'Moldova' },
  { iata: 'F7', icao: 'BBO', name: 'Flybaboo', country: 'Switzerland' },
  { iata: 'F8', name: 'Air2there', country: 'New Zealand' },
  { iata: 'F9', icao: 'FFT', name: 'Frontier Airlines', country: 'United States' },
  { iata: 'FA', icao: '4AA', name: 'Epic Holiday', country: 'United States' },
  { iata: 'FB', icao: 'LZB', name: 'Bulgaria Air', country: 'Bulgaria' },
  { iata: 'FC', icao: 'WBA', name: 'Finncomm Airlines', country: 'Finland' },
  { iata: 'FD', icao: 'AIQ', name: 'Thai AirAsia', country: 'Thailand' },
  { iata: 'FF', icao: 'FRF', name: 'Fly France', country: 'France' },
  { iata: 'FG', icao: 'AFG', name: 'Ariana Afghan Airlines', country: 'Afghanistan' },
  { iata: 'FH', icao: 'FHI', name: 'FlyHigh Airlines Ireland (FH)', country: 'Ireland' },
  { iata: 'FI', icao: 'ICE', name: 'Icelandair', country: 'Iceland' },
  { iata: 'FJ', icao: 'FJI', name: 'Air Pacific', country: 'Fiji' },
  { iata: 'FK', icao: 'WTA', name: 'Africa West', country: 'Togo' },
  { iata: 'FL', icao: 'TRS', name: 'AirTran Airways', country: 'United States' },
  { iata: 'FM', icao: 'CSH', name: 'Shanghai Airlines', country: 'China' },
  { iata: 'FN', name: 'Regional Airlines', country: 'Morocco' },
  { iata: 'FO', icao: 'ATM', name: 'Airlines Of Tasmania', country: 'Australia' },
  { iata: 'FP', icao: 'FRE', name: 'Freedom Air', country: 'United States' },
  { iata: 'FQ', icao: 'TCW', name: 'Thomas Cook Airlines', country: 'Belgium' },
  { iata: 'FR', icao: 'RYR', name: 'Ryanair', country: 'Ireland' },
  { iata: 'FS', icao: 'STU', name: 'Servicios de Transportes A', country: 'Argentina' },
  { iata: 'FT', icao: 'SRH', name: 'Siem Reap Airways', country: 'Cambodia' },
  { iata: 'FU', icao: 'FXX', name: 'Felix Airways', country: 'Yemen' },
  { iata: 'FV', icao: 'SDM', name: 'Rossiya-Russian Airlines', country: 'Russia' },
  { iata: 'FW', icao: 'IBX', name: 'Ibex Airlines', country: 'Japan' },
  { iata: 'FX', icao: 'FOX', name: 'FOX Linhas Aereas', country: 'Brazil' },
  { iata: 'FY', icao: 'FFM', name: 'Firefly', country: 'Malaysia' },
  { iata: 'FZ', icao: 'FDB', name: 'Fly Dubai', country: 'United Arab Emirates' },
  { iata: 'G0', icao: 'GHB', name: 'Ghana International Airlines', country: 'Ghana' },
  { iata: 'G1', icao: 'IG1', name: 'Indya Airline Group', country: 'India' },
  { iata: 'G3', icao: 'CIX', name: 'City Connexion Airlines', country: 'Burundi' },
  { iata: 'G4', icao: 'AAY', name: 'Allegiant Air', country: 'United States' },
  { iata: 'G5', name: 'Huaxia', country: 'China' },
  { iata: 'G6', name: 'Air Volga', country: 'Russia' },
  { iata: 'G7', icao: 'GJS', name: 'GoJet Airlines', country: 'United States' },
  { iata: 'G8', icao: 'GOW', name: 'Go Air', country: 'India' },
  { iata: 'G9', icao: 'ABY', name: 'Air Arabia', country: 'United Arab Emirates' },
  { iata: 'GA', icao: 'GIA', name: 'Garuda Indonesia', country: 'Indonesia' },
  { iata: 'GB', icao: 'BZE', name: 'BRAZIL AIR', country: 'Brazil' },
  { iata: 'GE', icao: 'TNA', name: 'TransAsia Airways', country: 'Taiwan' },
  { iata: 'GF', icao: 'GBA', name: 'Gulf Air Bahrain', country: 'Bahrain' },
  { iata: 'GG', icao: 'GUY', name: 'Air Guyane', country: 'French Guiana' },
  { iata: 'GH', icao: 'GLP', name: 'Globus', country: 'Russia' },
  { iata: 'GI', icao: 'IKA', name: 'Itek Air', country: 'Kyrgyzstan' },
  { iata: 'GJ', icao: 'EEU', name: 'Eurofly Service', country: 'Italy' },
  { iata: 'GK', name: 'Genesis', country: 'Pakistan' },
  { iata: 'GL', icao: 'GRL', name: 'Air Greenland', country: 'Denmark' },
  { iata: 'GM', icao: 'GER', name: 'German International Air Lines', country: 'Germany' },
  { iata: 'GN', name: 'GNB Linhas Aereas', country: 'Brazil' },
  { iata: 'GO', icao: 'KZU', name: 'Kuzu Airlines Cargo', country: 'Turkey' },
  { iata: 'GP', icao: 'GDR', name: 'Gadair European Airlines', country: 'Spain' },
  { iata: 'GR', icao: 'AUR', name: 'Aurigny Air Services', country: 'United Kingdom' },
  { iata: 'GS', icao: 'UPA', name: 'Air Foyle', country: 'United Kingdom' },
  { iata: 'GT', icao: 'GBL', name: 'GB Airways', country: 'United Kingdom' },
  { iata: 'GV', icao: 'ARF', name: 'Aero Flight', country: 'Germany' },
  { iata: 'GW', icao: 'KIL', name: 'Kuban Airlines', country: 'Russia' },
  { iata: 'GX', icao: 'GXG', name: 'GermanXL', country: 'Germany' },
  { iata: 'GY', icao: 'GBK', name: 'Gabon Airlines', country: 'Gabon' },
  { iata: 'GZ', icao: 'RAR', name: 'Air Rarotonga', country: 'Cook Islands' },
  { iata: 'H1', icao: 'HA1', name: 'Hankook Air US', country: 'United States' },
  { iata: 'H2', icao: 'SKU', name: 'Sky Airline', country: 'Chile' },
  { iata: 'H3', name: 'Harbour Air (Priv)', country: 'Canada' },
  { iata: 'H5', icao: 'RSY', name: 'I-Fly', country: 'Russia' },
  { iata: 'H6', icao: 'HAG', name: 'Hageland Aviation Services', country: 'United States' },
  { iata: 'H7', name: 'Eagle Air', country: 'Uganda' },
  { iata: 'H8', icao: 'KHB', name: 'Dalavia', country: 'Russia' },
  { iata: 'H9', name: 'PEGASUS AIRLINES-', country: 'Turkey' },
  { iata: 'HA', icao: 'HAL', name: 'Hawaiian Airlines', country: 'United States' },
  { iata: 'HC', icao: 'HYM', name: 'Himalayan Airlines', country: 'Nepal' },
  { iata: 'HD', icao: 'ADO', name: 'Hokkaido International Airlines', country: 'Japan' },
  { iata: 'HE', icao: 'LGW', name: 'Luftfahrtgesellschaft Walter', country: 'Germany' },
  { iata: 'HF', icao: 'HLF', name: 'Hapagfly', country: 'Germany' },
  { iata: 'HG', icao: 'NLY', name: 'Niki', country: 'Austria' },
  { iata: 'HH', icao: 'AHO', name: 'Air Hamburg (AHO)', country: 'Germany' },
  { iata: 'HI', name: 'Papillon Grand Canyon Helicopters', country: 'United States' },
  { iata: 'HK', name: 'Yangon Airways', country: 'Burma' },
  { iata: 'HM', icao: 'SEY', name: 'Air Seychelles', country: 'Seychelles' },
  { iata: 'HN', icao: 'HNX', name: 'Hankook Airline', country: 'South Korea' },
  { iata: 'HO', icao: 'DKH', name: 'Juneyao Airlines', country: 'China' },
  { iata: 'HP', icao: 'AWE', name: 'America West Airlines', country: 'United States' },
  { iata: 'HR', icao: 'CUA', name: 'China United Airlines', country: 'China' },
  { iata: 'HT', icao: 'IMP', name: 'Hellenic Imperial Airways', country: 'Greece' },
  { iata: 'HU', icao: 'CHH', name: 'Hainan Airlines', country: 'China' },
  { iata: 'HV', icao: 'TRA', name: 'Transavia Holland', country: 'Netherlands' },
  { iata: 'HW', icao: 'FHE', name: 'Hello', country: 'Switzerland' },
  { iata: 'HX', icao: 'CRK', name: 'Hong Kong Airlines', country: 'Hong Kong SAR of China' },
  { iata: 'HY', icao: 'UZB', name: 'Uzbekistan Airways', country: 'Uzbekistan' },
  { iata: 'HZ', icao: 'SOZ', name: 'Sat Airlines', country: 'Kazakhstan' },
  { iata: 'I2', icao: 'IBS', name: 'Iberia Express', country: 'Spain' },
  { iata: 'I3', name: 'ATA Airlines (Iran)', country: 'Iran' },
  { iata: 'I4', name: 'International AirLink', country: 'Jamaica' },
  { iata: 'I5', icao: 'IDS', name: 'Indonesia Sky', country: 'Indonesia' },
  { iata: 'I6', icao: 'MXI', name: 'MexicanaLink', country: 'Mexico' },
  { iata: 'I7', icao: 'PMW', name: 'Paramount Airways', country: 'India' },
  { iata: 'I8', name: 'IzAvia', country: 'Russia' },
  { iata: 'I9', icao: 'AEY', name: 'Air Italy', country: 'Italy' },
  { iata: 'IA', icao: 'IAW', name: 'Iraqi Airways', country: 'Iraq' },
  { iata: 'IB', icao: 'IBE', name: 'Iberia Airlines', country: 'Spain' },
  { iata: 'IC', icao: 'IAC', name: 'Indian Airlines', country: 'India' },
  { iata: 'ID', icao: 'ITK', name: 'Interlink Airlines', country: 'South Africa' },
  { iata: 'IE', icao: 'SOL', name: 'Solomon Airlines', country: 'Solomon Islands' },
  { iata: 'IF', icao: 'ISW', name: 'Islas Airways', country: 'Spain' },
  { iata: 'IG', icao: 'ISS', name: 'Meridiana', country: 'Italy' },
  { iata: 'II', icao: 'UWW', name: 'LSM International', country: 'Russia' },
  { iata: 'IJ', icao: 'SJO', name: 'Spring Airlines Japan', country: 'Japan' },
  { iata: 'IK', icao: 'ITX', name: 'Imair Airlines', country: 'Azerbaijan' },
  { iata: 'IN', icao: 'MAK', name: 'MAT Macedonian Airlines', country: 'Macedonia' },
  { iata: 'IO', icao: 'IAA', name: 'Indonesian Airlines', country: 'Indonesia' },
  { iata: 'IP', icao: 'ISX', name: 'Island Spirit', country: 'Iceland' },
  { iata: 'IQ', icao: 'AUB', name: 'Augsburg Airways', country: 'Germany' },
  { iata: 'IR', icao: 'IRA', name: 'Iran Air', country: 'Iran' },
  { iata: 'IS', name: 'Island Airlines', country: 'United States' },
  { iata: 'IT', icao: 'KFR', name: 'Kingfisher Airlines', country: 'India' },
  { iata: 'IV', icao: 'JET', name: 'Wind Jet', country: 'Italy' },
  { iata: 'IW', icao: 'WON', name: 'Wings Air', country: 'Indonesia' },
  { iata: 'IX', icao: 'AXB', name: 'Air India Express', country: 'India' },
  { iata: 'IY', icao: 'IYE', name: 'Yemenia', country: 'Yemen' },
  { iata: 'IZ', icao: 'AIZ', name: 'Arkia Israel Airlines', country: 'Israel' },
  { iata: 'J1', name: 'OneJet', country: 'United States' },
  { iata: 'J2', icao: 'AHY', name: 'Azerbaijan Airlines', country: 'Azerbaijan' },
  { iata: 'J3', icao: 'PLR', name: 'Northwestern Air', country: 'Canada' },
  { iata: 'J4', name: 'ALAK', country: 'Russia' },
  { iata: 'J5', name: 'Alaska Seaplane Service', country: 'United States' },
  { iata: 'J7', name: 'Denim Air', country: 'Norway' },
  { iata: 'J8', icao: 'BVT', name: 'Berjaya Air', country: 'Malaysia' },
  { iata: 'J9', icao: 'JZR', name: 'Jazeera Airways', country: 'Kuwait' },
  { iata: 'JA', icao: 'BON', name: 'Air Bosna', country: 'Bosnia and Herzegovina' },
  { iata: 'JB', icao: 'JBA', name: 'Helijet', country: 'Canada' },
  { iata: 'JC', icao: 'JEX', name: 'JAL Express', country: 'Japan' },
  { iata: 'JD', icao: 'JAS', name: 'Japan Air System', country: 'Japan' },
  { iata: 'JE', icao: 'MNO', name: 'Mango', country: 'South Africa' },
  { iata: 'JF', icao: 'JAF', name: 'Jetairfly', country: 'Belgium' },
  { iata: 'JG', name: 'Jetgo Australia', country: 'Australia' },
  { iata: 'JH', name: 'Fuji Dream Airlines', country: 'Japan' },
  { iata: 'JI', icao: 'MDW', name: 'Midway Airlines', country: 'United States' },
  { iata: 'JJ', icao: 'TAM', name: 'TAM Brazilian Airlines', country: 'Brazil' },
  { iata: 'JK', icao: 'JKK', name: 'Spanair', country: 'Spain' },
  { iata: 'JL', icao: 'JAL', name: 'Japan Airlines', country: 'Japan' },
  { iata: 'JM', icao: 'AJM', name: 'Air Jamaica', country: 'Jamaica' },
  { iata: 'JN', icao: 'XLA', name: 'Excel Airways', country: 'United Kingdom' },
  { iata: 'JO', icao: 'JAZ', name: 'JALways', country: 'Japan' },
  { iata: 'JP', icao: 'ADR', name: 'Adria Airways', country: 'Slovenia' },
  { iata: 'JQ', icao: 'JST', name: 'Jetstar Airways', country: 'Australia' },
  { iata: 'JR', icao: 'JOY', name: 'Joy Air', country: 'China' },
  { iata: 'JS', icao: 'KOR', name: 'Air Koryo', country: 'Democratic People\'s Republic of Korea' },
  { iata: 'JT', icao: 'LNI', name: 'Lion Mentari Airlines', country: 'Indonesia' },
  { iata: 'JU', icao: 'ASL', name: 'Air Serbia', country: 'Serbia' },
  { iata: 'JV', icao: 'BLS', name: 'Bearskin Lake Air Service', country: 'Canada' },
  { iata: 'JW', icao: 'APW', name: 'Arrow Air', country: 'United States' },
  { iata: 'JX', icao: 'JSR', name: 'Jusur airways', country: 'Egypt' },
  { iata: 'JY', icao: 'AXZ', name: 'Aereonautica militare', country: 'Italy' },
  { iata: 'JZ', icao: 'SKX', name: 'Skyways Express', country: 'Sweden' },
  { iata: 'K1', icao: 'KOQ', name: 'Kostromskie avialinii', country: 'Russia' },
  { iata: 'K2', icao: 'ELO', name: 'Eurolot', country: 'Poland' },
  { iata: 'K5', icao: 'SQH', name: 'SeaPort Airlines', country: 'United States' },
  { iata: 'K6', name: 'Cambodia Angkor Air (K6)', country: 'Cambodia' },
  { iata: 'K7', icao: 'KBR', name: 'KoralBlue Airlines', country: 'Egypt' },
  { iata: 'K8', name: 'Zambia Skyways', country: 'Zambia' },
  { iata: 'KA', icao: 'HDA', name: 'Dragonair', country: 'DRAGON' },
  { iata: 'KB', icao: 'DRK', name: 'Druk Air', country: 'Bhutan' },
  { iata: 'KC', icao: 'KZR', name: 'Air Astana', country: 'Kazakhstan' },
  { iata: 'KD', icao: 'KNI', name: 'KD Avia', country: 'Russia' },
  { iata: 'KE', icao: 'KAL', name: 'Korean Air', country: 'Republic of Korea' },
  { iata: 'KF', icao: 'BLF', name: 'Blue1', country: 'Finland' },
  { iata: 'KG', icao: 'RAW', name: 'Royal Airways', country: 'United States' },
  { iata: 'KH', icao: 'KHK', name: 'Kharkiv Airlines', country: 'Ukraine' },
  { iata: 'KI', icao: 'DHI', name: 'Adam Air', country: 'Indonesia' },
  { iata: 'KJ', icao: 'LAJ', name: 'British Mediterranean Airways', country: 'United Kingdom' },
  { iata: 'KK', icao: 'KKK', name: 'Atlasjet', country: 'Turkey' },
  { iata: 'KL', icao: 'KLM', name: 'KLM Royal Dutch Airlines', country: 'Netherlands' },
  { iata: 'KM', icao: 'AMC', name: 'Air Malta', country: 'Malta' },
  { iata: 'KN', name: 'China United', country: 'China' },
  { iata: 'KO', icao: 'AER', name: 'Alaska Central Express', country: 'United States' },
  { iata: 'KP', icao: 'DWA', name: 'Dense Airways', country: 'United States' },
  { iata: 'KQ', icao: 'KQA', name: 'Kenya Airways', country: 'Kenya' },
  { iata: 'KR', icao: 'CWK', name: 'Comores Airlines', country: 'Comoros' },
  { iata: 'KS', icao: 'PEN', name: 'Peninsula Airways', country: 'United States' },
  { iata: 'KT', icao: 'VKJ', name: 'VickJet', country: 'France' },
  { iata: 'KU', icao: 'KAC', name: 'Kuwait Airways', country: 'Kuwait' },
  { iata: 'KV', icao: 'MVD', name: 'Kavminvodyavia', country: 'Russia' },
  { iata: 'KW', name: 'Carnival Air Lines', country: 'United States' },
  { iata: 'KX', icao: 'CAY', name: 'Cayman Airways', country: 'Cayman Islands' },
  { iata: 'KY', icao: 'KSY', name: 'KSY', country: 'Greece' },
  { iata: 'KZ', icao: 'DC2', name: 'Dense Connection', country: 'United States' },
  { iata: 'L1', icao: 'AL1', name: 'All Argentina', country: 'Argentina' },
  { iata: 'L3', icao: 'LTO', name: 'LTU Austria', country: 'Austria' },
  { iata: 'L4', icao: 'LJJ', name: 'Luchsh Airlines', country: 'Russia' },
  { iata: 'L5', icao: 'LTR', name: 'Lufttransport', country: 'Norway' },
  { iata: 'L6', icao: 'MAI', name: 'Mauritania Airlines International', country: 'Mauritania' },
  { iata: 'L7', name: 'Lugansk Airlines', country: 'Ukraine' },
  { iata: 'L8', icao: 'LBL', name: 'Line Blue', country: 'Germany' },
  { iata: 'L9', icao: 'AL3', name: 'All Asia', country: 'China' },
  { iata: 'LA', icao: 'LAN', name: 'LAN Airlines', country: 'Chile' },
  { iata: 'LB', name: 'Air Costa', country: 'India' },
  { iata: 'LC', icao: 'VLO', name: 'Varig Log', country: 'Brazil' },
  { iata: 'LE', icao: 'LTY', name: 'Liberty Airways', country: 'United States' },
  { iata: 'LF', icao: 'NDC', name: 'FlyNordic', country: 'Sweden' },
  { iata: 'LG', icao: 'LGL', name: 'Luxair', country: 'Luxembourg' },
  { iata: 'LH', icao: 'DLH', name: 'Lufthansa', country: 'Germany' },
  { iata: 'LI', icao: 'LIA', name: 'Leeward Islands Air Transport', country: 'Antigua and Barbuda' },
  { iata: 'LJ', icao: 'JNA', name: 'Jin Air', country: 'South Korea' },
  { iata: 'LK', icao: 'LXR', name: 'Air Luxor', country: 'Portugal' },
  { iata: 'LM', icao: 'LAM', name: 'Linhas A', country: 'Mozambique' },
  { iata: 'LN', icao: 'LAA', name: 'Libyan Arab Airlines', country: 'Libya' },
  { iata: 'LO', icao: 'LOT', name: 'LOT Polish Airlines', country: 'Poland' },
  { iata: 'LP', icao: 'LPE', name: 'LAN Peru', country: 'Peru' },
  { iata: 'LQ', icao: 'LMM', name: 'LCM AIRLINES', country: 'Russia' },
  { iata: 'LR', icao: 'LRC', name: 'LACSA', country: 'Costa Rica' },
  { iata: 'LS', icao: 'EXS', name: 'Jet2.com', country: 'United Kingdom' },
  { iata: 'LT', icao: 'LTU', name: 'Air Lituanica', country: 'Lithuania' },
  { iata: 'LU', icao: 'LXP', name: 'LAN Express', country: 'Chile' },
  { iata: 'LV', icao: 'LBC', name: 'Albanian Airlines', country: 'Albania' },
  { iata: 'LW', icao: 'NMI', name: 'Pacific Wings', country: 'United States' },
  { iata: 'LX', icao: 'SWR', name: 'Swiss International Air Lines', country: 'Switzerland' },
  { iata: 'LY', icao: 'ELY', name: 'El Al Israel Airlines', country: 'Israel' },
  { iata: 'M1', icao: 'M1F', name: 'Maryland Air', country: 'United States' },
  { iata: 'M2', name: 'MHS Aviation GmbH', country: 'Germany' },
  { iata: 'M3', icao: 'TUS', name: 'ABSA - Aerolinhas Brasileiras', country: 'Brazil' },
  { iata: 'M4', icao: '1QA', name: 'Marysya Airlines', country: 'Russia' },
  { iata: 'M5', icao: 'KEN', name: 'Kenmore Air', country: 'United States' },
  { iata: 'M7', icao: 'MAA', name: 'MasAir', country: 'Mexico' },
  { iata: 'M8', icao: 'TNU', name: 'TransNusa Air', country: 'Indonesia' },
  { iata: 'M9', icao: 'MSI', name: 'Motor Sich', country: 'Ukraine' },
  { iata: 'MA', icao: 'MAH', name: 'Malév', country: 'Hungary' },
  { iata: 'MB', icao: 'MNB', name: 'MNG Airlines', country: 'Turkey' },
  { iata: 'MD', icao: 'MDG', name: 'Air Madagascar', country: 'Madagascar' },
  { iata: 'ME', icao: 'MEA', name: 'Middle East Airlines', country: 'Lebanon' },
  { iata: 'MF', icao: 'CXA', name: 'Xiamen Airlines', country: 'China' },
  { iata: 'MH', icao: 'MAS', name: 'Malaysia Airlines', country: 'Malaysia' },
  { iata: 'MI', icao: 'SLK', name: 'SilkAir', country: 'Singapore' },
  { iata: 'MJ', icao: 'LPR', name: 'L', country: 'Argentina' },
  { iata: 'MK', icao: 'MAU', name: 'Air Mauritius', country: 'Mauritius' },
  { iata: 'ML', icao: 'MAV', name: 'Maldivo Airlines', country: 'Maldives' },
  { iata: 'MM', name: 'Peach Aviation', country: 'Japan' },
  { iata: 'MN', icao: 'CAW', name: 'Comair', country: 'South Africa' },
  { iata: 'MO', icao: 'AUH', name: 'Abu Dhabi Amiri Flight', country: 'United Arab Emirates' },
  { iata: 'MP', icao: 'MPH', name: 'Martinair', country: 'Netherlands' },
  { iata: 'MQ', icao: 'EGF', name: 'American Eagle Airlines', country: 'United States' },
  { iata: 'MR', icao: 'OME', name: 'Homer Air', country: 'Germany' },
  { iata: 'MS', icao: 'MSR', name: 'Egyptair', country: 'Egypt' },
  { iata: 'MT', icao: 'TCX', name: 'Thomas Cook Airlines', country: 'United Kingdom' },
  { iata: 'MU', icao: 'CES', name: 'China Eastern Airlines', country: 'China' },
  { iata: 'MW', icao: 'MYD', name: 'Maya Island Air', country: 'Belize' },
  { iata: 'MX', icao: 'MXA', name: 'Mexicana de Aviaci', country: 'Mexico' },
  { iata: 'MY', icao: 'MWA', name: 'Midwest Airlines (Egypt)', country: 'Egypt' },
  { iata: 'MZ', icao: 'MNA', name: 'Merpati Nusantara Airlines', country: 'Indonesia' },
  { iata: 'N0', name: 'Norte Lineas Aereas', country: 'Argentina' },
  { iata: 'N1', name: 'N1', country: 'Peru' },
  { iata: 'N4', icao: 'J88', name: 'Regionalia México', country: 'Mexico' },
  { iata: 'N5', icao: 'SGY', name: 'Skagway Air Service', country: 'United States' },
  { iata: 'N7', icao: 'N77', name: 'All Spain', country: 'Spain' },
  { iata: 'N8', icao: 'NCR', name: 'National Air Cargo', country: 'United States' },
  { iata: 'N9', icao: 'N99', name: 'All Europe', country: 'United Kingdom' },
  { iata: 'NA', name: 'Al-Naser Airlines', country: 'Iraq' },
  { iata: 'NB', icao: 'SNB', name: 'Sterling Airlines', country: 'Denmark' },
  { iata: 'NC', icao: 'NJS', name: 'National Jet Systems', country: 'Australia' },
  { iata: 'NE', icao: 'ESK', name: 'SkyEurope', country: 'Slovakia' },
  { iata: 'NF', icao: 'AVN', name: 'Air Vanuatu', country: 'Vanuatu' },
  { iata: 'NG', icao: 'LDA', name: 'Lauda Air', country: 'Austria' },
  { iata: 'NH', icao: 'ANA', name: 'All Nippon Airways', country: 'Japan' },
  { iata: 'NI', icao: 'PGA', name: 'Portugalia', country: 'Portugal' },
  { iata: 'NJ', icao: 'NGB', name: 'Nordic Global Airlines', country: 'Finland' },
  { iata: 'NK', icao: 'NKS', name: 'Spirit Airlines', country: 'United States' },
  { iata: 'NL', icao: 'SAI', name: 'Shaheen Air International', country: 'Pakistan' },
  { iata: 'NM', icao: 'DRD', name: 'Air Madrid', country: 'Spain' },
  { iata: 'NN', icao: 'MOV', name: 'VIM Airlines', country: 'Russia' },
  { iata: 'NP', icao: 'NIA', name: 'Nile Air', country: 'Egypt' },
  { iata: 'NQ', icao: 'AJX', name: 'Air Japan', country: 'Japan' },
  { iata: 'NR', icao: 'JTO', name: 'Jettor Airlines', country: 'Hong Kong' },
  { iata: 'NS', name: 'Caucasus Airlines', country: 'Georgia' },
  { iata: 'NT', icao: 'IBB', name: 'Binter Canarias', country: 'Spain' },
  { iata: 'NU', icao: 'JTA', name: 'Japan Transocean Air', country: 'Japan' },
  { iata: 'NW', icao: 'NWA', name: 'Northwest Airlines', country: 'United States' },
  { iata: 'NX', icao: 'AMU', name: 'Air Macau', country: 'Macao' },
  { iata: 'NY', icao: 'FXI', name: 'Air Iceland', country: 'Iceland' },
  { iata: 'NZ', icao: 'ANZ', name: 'Air New Zealand', country: 'New Zealand' },
  { iata: 'O1', icao: 'OAB', name: 'Orbit Airlines Azerbaijan', country: 'Azerbaijan' },
  { iata: 'O2', name: 'Oceanic Airlines', country: 'Guinea' },
  { iata: 'O6', icao: 'ONE', name: 'Oceanair', country: 'Brazil' },
  { iata: 'O7', icao: 'OZJ', name: 'Ozjet Airlines', country: 'Australia' },
  { iata: 'O8', icao: 'OHK', name: 'Oasis Hong Kong Airlines', country: 'Hong Kong' },
  { iata: 'OA', icao: 'OAL', name: 'Olympic Airlines', country: 'Greece' },
  { iata: 'OB', icao: 'ASZ', name: 'Astrakhan Airlines', country: 'Russia' },
  { iata: 'OC', name: 'Catovair', country: 'Mauritius' },
  { iata: 'OD', icao: 'MXD', name: 'Malindo Air', country: 'Malaysia' },
  { iata: 'OF', icao: 'FIF', name: 'Air Finland', country: 'Finland' },
  { iata: 'OG', name: 'AirOnix', country: 'Ukraine' },
  { iata: 'OH', icao: 'COM', name: 'Comair', country: 'United States' },
  { iata: 'OI', icao: 'ORC', name: 'Orchid Airlines', country: 'Australia' },
  { iata: 'OJ', icao: 'OLA', name: 'Overland Airways', country: 'Nigeria' },
  { iata: 'OK', icao: 'CSA', name: 'Czech Airlines', country: 'Czech Republic' },
  { iata: 'OL', icao: 'OLT', name: 'Ostfriesische Lufttransport', country: 'Germany' },
  { iata: 'OM', icao: 'MGL', name: 'MIAT Mongolian Airlines', country: 'Mongolia' },
  { iata: 'ON', icao: 'RON', name: 'Nauru Air Corporation', country: 'Nauru' },
  { iata: 'OO', icao: 'SKW', name: 'SkyWest', country: 'United States' },
  { iata: 'OP', icao: 'PPL', name: 'Air Pegasus', country: 'India' },
  { iata: 'OQ', icao: 'CQN', name: 'Chongqing Airlines', country: 'China' },
  { iata: 'OR', icao: 'TFL', name: 'Arkefly', country: 'Netherlands' },
  { iata: 'OS', icao: 'AUA', name: 'Austrian Airlines', country: 'Austria' },
  { iata: 'OT', icao: 'PEL', name: 'Aeropelican Air Services', country: 'Australia' },
  { iata: 'OU', icao: 'CTN', name: 'Croatia Airlines', country: 'Croatia' },
  { iata: 'OV', icao: 'ELL', name: 'Estonian Air', country: 'Estonia' },
  { iata: 'OX', icao: 'OEA', name: 'Orient Thai Airlines', country: 'Thailand' },
  { iata: 'OY', icao: 'OAE', name: 'Omni Air International', country: 'United States' },
  { iata: 'OZ', icao: 'AAR', name: 'Asiana Airlines', country: 'Republic of Korea' },
  { iata: 'P0', name: 'Proflight Commuter Services', country: 'Zambia' },
  { iata: 'P4', name: 'Patriot Airways', country: 'United States' },
  { iata: 'P5', icao: 'RPB', name: 'AeroRep', country: 'Colombia' },
  { iata: 'P7', icao: 'REP', name: 'Regional Paraguaya', country: 'Paraguay' },
  { iata: 'P8', icao: 'MKG', name: 'Air Mekong', country: 'Vietnam' },
  { iata: 'P9', name: 'Peruvian Airlines', country: 'Peru' },
  { iata: 'PA', icao: 'IPV', name: 'Parmiss Airlines (IPV)', country: 'Iran' },
  { iata: 'PC', icao: 'PGT', name: 'Pegasus Airlines', country: 'Turkey' },
  { iata: 'PD', icao: 'POE', name: 'Porter Airlines', country: 'Canada' },
  { iata: 'PE', icao: 'AEL', name: 'Air Europe', country: 'Italy' },
  { iata: 'PF', name: 'Primera Air', country: 'Iceland' },
  { iata: 'PG', icao: 'BKP', name: 'Bangkok Airways', country: 'Thailand' },
  { iata: 'PH', icao: 'PAO', name: 'Polynesian Airlines', country: 'Samoa' },
  { iata: 'PI', icao: 'PDT', name: 'Piedmont Airlines (1948-1989)', country: 'United States' },
  { iata: 'PJ', icao: 'SPM', name: 'Air Saint Pierre', country: 'France' },
  { iata: 'PK', icao: 'PIA', name: 'Pakistan International Airlines', country: 'Pakistan' },
  { iata: 'PL', icao: 'PLI', name: 'Aeroper', country: 'Peru' },
  { iata: 'PM', icao: 'TOS', name: 'Tropic Air', country: 'Belize' },
  { iata: 'PN', icao: 'CHB', name: 'West Air China', country: 'China' },
  { iata: 'PO', icao: 'FPT', name: 'FlyPortugal', country: 'Portugal' },
  { iata: 'PP', icao: 'AI0', name: 'Air Indus', country: 'Pakistan' },
  { iata: 'PQ', icao: 'LOO', name: 'LSM Airlines', country: 'Russia' },
  { iata: 'PR', icao: 'PAL', name: 'Philippine Airlines', country: 'Philippines' },
  { iata: 'PS', icao: 'AUI', name: 'Ukraine International Airlines', country: 'Ukraine' },
  { iata: 'PT', name: 'Red Jet Andes', country: 'Peru' },
  { iata: 'PU', icao: 'PUA', name: 'PLUNA', country: 'Uruguay' },
  { iata: 'PV', icao: 'PNR', name: 'PAN Air', country: 'Spain' },
  { iata: 'PW', icao: 'PRF', name: 'Precision Air', country: 'Tanzania' },
  { iata: 'PX', icao: 'ANG', name: 'Air Niugini', country: 'Papua New Guinea' },
  { iata: 'PY', icao: 'SLM', name: 'Surinam Airways', country: 'Suriname' },
  { iata: 'PZ', icao: 'LAP', name: 'TAM Mercosur', country: 'Paraguay' },
  { iata: 'Q2', name: 'Maldivian', country: 'Maldives' },
  { iata: 'Q3', icao: 'QER', name: 'SOCHI AIR CHATER', country: 'Russia' },
  { iata: 'Q4', icao: 'SAE', name: 'SOCHI AIR EXPRESS', country: 'Russia' },
  { iata: 'Q5', icao: 'MLA', name: '40-Mile Air', country: 'United States' },
  { iata: 'Q6', icao: 'CDP', name: 'Aero Condor Peru', country: 'Peru' },
  { iata: 'Q7', name: 'SkyBahamas Airlines', country: 'Bahamas' },
  { iata: 'Q8', icao: 'PEC', name: 'Pacific East Asia Cargo Airlines', country: 'Philippines' },
  { iata: 'Q9', icao: 'NAK', name: 'Arik Niger', country: 'Niger' },
  { iata: 'QA', name: 'Click (Mexicana)', country: 'Mexico' },
  { iata: 'QB', icao: 'GFG', name: 'Georgian National Airlines', country: 'Georgia' },
  { iata: 'QC', name: 'Camair-co', country: 'Cameroon' },
  { iata: 'QD', icao: 'DOB', name: 'Dobrolet', country: 'Russia' },
  { iata: 'QF', icao: 'QFA', name: 'Qantas', country: 'Australia' },
  { iata: 'QG', name: 'Citilink Indonesia', country: 'Indonesia' },
  { iata: 'QH', icao: 'FLZ', name: 'Air Florida', country: 'United States' },
  { iata: 'QI', icao: 'CIM', name: 'Cimber Air', country: 'Denmark' },
  { iata: 'QJ', name: 'Jet Airways', country: 'United States' },
  { iata: 'QK', icao: 'JZA', name: 'Air Canada Jazz', country: 'Canada' },
  { iata: 'QL', icao: 'RLN', name: 'Aero Lanka', country: 'Sri Lanka' },
  { iata: 'QM', icao: 'AML', name: 'Air Malawi', country: 'Malawi' },
  { iata: 'QO', icao: 'OGN', name: 'Origin Pacific Airways', country: 'New Zealand' },
  { iata: 'QP', name: 'Air Kenya (Priv)', country: 'Kenya' },
  { iata: 'QQ', icao: 'UTY', name: 'Alliance Airlines', country: 'Australia' },
  { iata: 'QR', icao: 'QTR', name: 'Qatar Airways', country: 'Qatar' },
  { iata: 'QS', icao: 'TVS', name: 'Travel Service', country: 'Czech Republic' },
  { iata: 'QT', icao: 'TPA', name: 'TAMPA', country: 'Colombia' },
  { iata: 'QU', icao: 'UGX', name: 'East African', country: 'Uganda' },
  { iata: 'QV', icao: 'LAO', name: 'Lao Airlines', country: 'Lao Peoples Democratic Republic' },
  { iata: 'QW', icao: 'BWG', name: 'Blue Wings', country: 'Germany' },
  { iata: 'QX', icao: 'QXE', name: 'Horizon Air', country: 'United States' },
  { iata: 'QY', name: 'Red Jet Canada', country: 'Canada' },
  { iata: 'QZ', icao: 'AWQ', name: 'Indonesia AirAsia', country: 'Indonesia' },
  { iata: 'R2', icao: 'ORB', name: 'Orenburg Airlines', country: 'Russia' },
  { iata: 'R3', icao: 'SYL', name: 'Aircompany Yakutia', country: 'Russia' },
  { iata: 'R4', name: 'Rossiya', country: 'Russia' },
  { iata: 'R5', icao: 'MAC', name: 'Malta Air Charter', country: 'Malta' },
  { iata: 'R6', name: 'RACSA', country: 'Guatemala' },
  { iata: 'R7', icao: 'OCA', name: 'Aserca Airlines', country: 'Venezuela' },
  { iata: 'R8', icao: 'RRJ', name: 'AirRussia', country: 'Russia' },
  { iata: 'RA', icao: 'RNA', name: 'Nepal Airlines', country: 'Nepal' },
  { iata: 'RB', icao: 'SYR', name: 'Syrian Arab Airlines', country: 'Syrian Arab Republic' },
  { iata: 'RC', icao: 'FLI', name: 'Atlantic Airways', country: 'Faroe Islands' },
  { iata: 'RD', icao: 'RYN', name: 'Ryan International Airlines', country: 'United States' },
  { iata: 'RE', icao: 'REA', name: 'Aer Arann', country: 'Ireland' },
  { iata: 'RF', icao: 'FWL', name: 'Florida West International Airways', country: 'United States' },
  { iata: 'RG', icao: 'VRN', name: 'VRG Linhas Aereas', country: 'Brazil' },
  { iata: 'RH', icao: 'RPH', name: 'Republic Express Airlines', country: 'Indonesia' },
  { iata: 'RI', icao: 'MDL', name: 'Mandala Airlines', country: 'Indonesia' },
  { iata: 'RJ', icao: 'RJA', name: 'Royal Jordanian', country: 'Jordan' },
  { iata: 'RK', icao: 'RKA', name: 'Air Afrique', country: 'Ivory Coast' },
  { iata: 'RL', icao: 'RFJ', name: 'Royal Falcon', country: 'Jordan' },
  { iata: 'RM', icao: 'RNY', name: 'Rainbow Air US', country: 'United States' },
  { iata: 'RN', icao: 'RAB', name: 'Rainbow Air (RAI)', country: 'United States' },
  { iata: 'RO', icao: 'ROT', name: 'Tarom', country: 'Romania' },
  { iata: 'RP', icao: 'CHQ', name: 'Chautauqua Airlines', country: 'United States' },
  { iata: 'RQ', icao: 'KMF', name: 'Kam Air', country: 'Afghanistan' },
  { iata: 'RR', icao: 'RXR', name: 'REXAIR VIRTUEL', country: 'France' },
  { iata: 'RS', icao: 'SKV', name: 'Sky Regional', country: 'Canada' },
  { iata: 'RT', name: 'Real Tonga', country: 'Tonga' },
  { iata: 'RU', icao: 'RUE', name: 'Rainbow Air Euro', country: 'United Kingdom' },
  { iata: 'RV', icao: 'CPN', name: 'Caspian Airlines', country: 'Iran' },
  { iata: 'RW', icao: 'RPA', name: 'Republic Airlines', country: 'United States' },
  { iata: 'RX', icao: 'RPO', name: 'Rainbow Air Polynesia', country: 'United States' },
  { iata: 'RY', icao: 'RAY', name: 'Rainbow Air Canada', country: 'Canada' },
  { iata: 'RZ', name: 'Euro Exec Express', country: 'Sweden' },
  { iata: 'S0', icao: 'SAL', name: 'Spike Airlines', country: 'United States' },
  { iata: 'S1', icao: 'SA1', name: 'Serbian Airlines', country: 'Serbia' },
  { iata: 'S2', icao: 'RSH', name: 'Air Sahara', country: 'India' },
  { iata: 'S3', icao: 'BBR', name: 'Santa Barbara Airlines', country: 'Venezuela' },
  { iata: 'S4', icao: 'RZO', name: 'SATA International', country: 'Portugal' },
  { iata: 'S5', icao: 'TCF', name: 'Shuttle America', country: 'United States' },
  { iata: 'S6', name: 'Salmon Air', country: 'United States' },
  { iata: 'S7', icao: 'SBI', name: 'S7 Airlines', country: 'Russia' },
  { iata: 'S8', icao: 'SBD', name: 'Snowbird Airlines', country: 'Finland' },
  { iata: 'S9', name: 'Starbow Airlines', country: 'Ghana' },
  { iata: 'SA', icao: 'SAA', name: 'South African Airways', country: 'South Africa' },
  { iata: 'SB', icao: 'ACI', name: 'Air Caledonie International', country: 'France' },
  { iata: 'SC', icao: 'CDG', name: 'Shandong Airlines', country: 'China' },
  { iata: 'SD', icao: 'SUD', name: 'Sudan Airways', country: 'Sudan' },
  { iata: 'SE', icao: 'SEU', name: 'XL Airways France', country: 'France' },
  { iata: 'SG', icao: 'SEJ', name: 'Spicejet', country: 'India' },
  { iata: 'SH', icao: 'SHA', name: 'Sharp Airlines', country: 'Australia' },
  { iata: 'SI', icao: 'SIH', name: 'Skynet Airlines', country: 'Ireland' },
  { iata: 'SJ', icao: 'SJY', name: 'Sriwijaya Air', country: 'Indonesia' },
  { iata: 'SK', icao: 'SAS', name: 'Scandinavian Airlines System', country: 'Sweden' },
  { iata: 'SL', name: 'Thai Lion Air', country: 'Thailand' },
  { iata: 'SM', icao: 'MNP', name: 'Spirit of Manila Airlines', country: 'Philippines' },
  { iata: 'SN', icao: 'DAT', name: 'Brussels Airlines', country: 'Belgium' },
  { iata: 'SO', icao: 'SLC', name: 'Salsa d\\\\\'Haiti', country: 'Haiti' },
  { iata: 'SP', icao: 'SAT', name: 'SATA Air Acores', country: 'Portugal' },
  { iata: 'SQ', icao: 'SIA', name: 'Singapore Airlines', country: 'Singapore' },
  { iata: 'SR', icao: 'SWR', name: 'Swissair', country: 'Switzerland' },
  { iata: 'SS', icao: 'CRL', name: 'Corsairfly', country: 'France' },
  { iata: 'ST', icao: 'GMI', name: 'Germania', country: 'Germany' },
  { iata: 'SU', icao: 'AFL', name: 'Aeroflot Russian Airlines', country: 'Russia' },
  { iata: 'SV', icao: 'SVA', name: 'Saudi Arabian Airlines', country: 'Saudi Arabia' },
  { iata: 'SW', icao: 'NMB', name: 'Air Namibia', country: 'Namibia' },
  { iata: 'SX', name: 'SkyWork Airlines', country: 'Switzerland' },
  { iata: 'SY', icao: 'SCX', name: 'Sun Country Airlines', country: 'United States' },
  { iata: 'SZ', name: 'Salzburg arrows', country: 'Austria' },
  { iata: 'T0', name: 'TACA Peru', country: 'Peru' },
  { iata: 'T2', icao: 'TCG', name: 'Thai Air Cargo', country: 'Thailand' },
  { iata: 'T3', icao: 'EZE', name: 'Eastern Airways', country: 'United Kingdom' },
  { iata: 'T4', icao: 'HEJ', name: 'Hellas Jet', country: 'Greece' },
  { iata: 'T5', icao: 'TUA', name: 'Turkmenistan Airlines', country: 'Turkmenistan' },
  { iata: 'T6', icao: 'TP6', name: 'Trans Pas Air', country: 'United States' },
  { iata: 'T7', icao: 'TJT', name: 'Twin Jet', country: 'France' },
  { iata: 'TA', icao: 'TAT', name: 'Grupo TACA', country: 'Costa Rica' },
  { iata: 'TB', icao: 'TBZ', name: 'TrasBrasil', country: 'Brazil' },
  { iata: 'TC', icao: 'ATC', name: 'Air Tanzania', country: 'Tanzania' },
  { iata: 'TD', icao: 'LUR', name: 'Atlantis European Airways', country: 'Armenia' },
  { iata: 'TE', icao: 'LIL', name: 'FlyLal', country: 'Lithuania' },
  { iata: 'TF', icao: 'SCW', name: 'Malmö Aviation', country: 'Sweden' },
  { iata: 'TG', icao: 'THA', name: 'Thai Airways International', country: 'Thailand' },
  { iata: 'TH', icao: 'THS', name: 'TransBrasil Airlines', country: 'Brazil' },
  { iata: 'TI', icao: 'THI', name: 'TransHolding', country: 'Brazil' },
  { iata: 'TJ', icao: 'TJA', name: 'T.J. Air', country: 'United States' },
  { iata: 'TK', icao: 'THY', name: 'Turkish Airlines', country: 'Turkey' },
  { iata: 'TL', icao: 'ANO', name: 'Airnorth', country: 'Australia' },
  { iata: 'TM', name: 'Air Mozambique', country: 'Mozambique' },
  { iata: 'TN', icao: 'THT', name: 'Air Tahiti Nui', country: 'France' },
  { iata: 'TO', icao: 'TVF', name: 'Transavia France', country: 'France' },
  { iata: 'TP', icao: 'TAP', name: 'TAP Portugal', country: 'Portugal' },
  { iata: 'TQ', icao: 'TXW', name: 'Texas Wings', country: 'United States' },
  { iata: 'TR', icao: 'TGW', name: 'Tiger Airways', country: 'Singapore' },
  { iata: 'TS', icao: 'TSC', name: 'Air Transat', country: 'Canada' },
  { iata: 'TT', icao: 'TGW', name: 'Tiger Airways Australia', country: 'Australia' },
  { iata: 'TU', icao: 'TAR', name: 'Tunisair', country: 'Tunisia' },
  { iata: 'TV', icao: 'VEX', name: 'Virgin Express', country: 'Belgium' },
  { iata: 'TW', icao: 'TWB', name: 'Tway Airlines', country: 'South Korea' },
  { iata: 'TX', icao: 'FWI', name: 'Air Caraïbes', country: 'France' },
  { iata: 'TY', icao: 'IWD', name: 'Iberworld', country: 'Spain' },
  { iata: 'TZ', icao: 'SCO', name: 'Scoot', country: 'Singapore' },
  { iata: 'U1', icao: 'ABI', name: 'Aviabus', country: 'Russia' },
  { iata: 'U2', icao: 'EZY', name: 'easyJet', country: 'United Kingdom' },
  { iata: 'U3', icao: 'AIA', name: 'Avies', country: 'Estonia' },
  { iata: 'U4', icao: 'PMT', name: 'PMTair', country: 'Cambodia' },
  { iata: 'U5', icao: 'GWY', name: 'USA3000 Airlines', country: 'United States' },
  { iata: 'U6', icao: 'SVR', name: 'Ural Airlines', country: 'Russia' },
  { iata: 'U7', name: 'Northern Dene Airways', country: 'Canada' },
  { iata: 'U8', icao: 'RNV', name: 'Armavia', country: 'Armenia' },
  { iata: 'U9', icao: 'TAK', name: 'Tatarstan Airlines', country: 'Russia' },
  { iata: 'UA', icao: 'UAL', name: 'United Airlines', country: 'United States' },
  { iata: 'UB', icao: 'UBA', name: 'Myanma Airways', country: 'Myanmar' },
  { iata: 'UD', icao: 'HER', name: 'Hex\'Air', country: 'France' },
  { iata: 'UE', icao: 'NAS', name: 'Nasair', country: 'Eritrea' },
  { iata: 'UF', icao: 'UKM', name: 'UM Airlines', country: 'Ukraine' },
  { iata: 'UG', icao: 'TUI', name: 'Tuninter', country: 'Tunisia' },
  { iata: 'UH', name: 'US Helicopter Corporation', country: 'United States' },
  { iata: 'UI', icao: 'ECA', name: 'Eurocypria Airlines', country: 'Cyprus' },
  { iata: 'UJ', icao: 'LMU', name: 'AlMasria Universal Airlines', country: 'Egypt' },
  { iata: 'UK', icao: 'VTI', name: 'Air Vistara', country: 'India' },
  { iata: 'UL', icao: 'ALK', name: 'SriLankan Airlines', country: 'Sri Lanka' },
  { iata: 'UM', icao: 'AZW', name: 'Air Zimbabwe', country: 'Zimbabwe' },
  { iata: 'UN', icao: 'TSO', name: 'Transaero Airlines', country: 'Russia' },
  { iata: 'UO', icao: 'HKE', name: 'Hong Kong Express Airways', country: 'Hong Kong SAR of China' },
  { iata: 'UP', icao: 'BHS', name: 'Bahamasair', country: 'Bahamas' },
  { iata: 'UQ', icao: 'SJU', name: 'Skyjet Airlines', country: 'Uganda' },
  { iata: 'UR', name: 'UTair-Express', country: 'Russia' },
  { iata: 'US', icao: 'USA', name: 'US Airways', country: 'United States' },
  { iata: 'UT', icao: 'UTA', name: 'UTair Aviation', country: 'Russia' },
  { iata: 'UU', icao: 'REU', name: 'Air Austral', country: 'France' },
  { iata: 'UW', name: 'UVT Aero', country: 'Russia' },
  { iata: 'UX', icao: 'AEA', name: 'Air Europa', country: 'Spain' },
  { iata: 'UZ', icao: 'BRQ', name: 'El-Buraq Air Transport', country: 'Libya' },
  { iata: 'V0', icao: 'VCV', name: 'Conviasa', country: 'Venezuela' },
  { iata: 'V1', icao: 'VIA', name: 'VIA Líneas Aéreas', country: 'Argentina' },
  { iata: 'V2', icao: 'RBY', name: 'Vision Airlines (V2)', country: 'United States' },
  { iata: 'V3', icao: 'KRP', name: 'Carpatair', country: 'Romania' },
  { iata: 'V5', name: 'Danube Wings (V5)', country: 'Slovakia' },
  { iata: 'V6', name: 'VIP Ecuador', country: 'Ecuador' },
  { iata: 'V7', icao: 'VOE', name: 'VOLOTEA Airways', country: 'Spain' },
  { iata: 'V8', icao: 'VAS', name: 'ATRAN Cargo Airlines', country: 'Russian Federation' },
  { iata: 'V9', icao: 'HCW', name: 'Star1 Airlines', country: 'Lithuania' },
  { iata: 'VA', icao: 'VOZ', name: 'Virgin Australia', country: 'Australia' },
  { iata: 'VC', name: 'Strategic Airlines', country: 'Australia' },
  { iata: 'VD', name: 'Air Libert', country: 'France' },
  { iata: 'VE', icao: 'VLE', name: 'Volare Airlines', country: 'Italy' },
  { iata: 'VF', icao: 'VLU', name: 'Valuair', country: 'Singapore' },
  { iata: 'VG', icao: 'VLM', name: 'VLM Airlines', country: 'Belgium' },
  { iata: 'VH', icao: 'VNP', name: 'Virgin Pacific', country: 'Fiji' },
  { iata: 'VI', icao: 'VDA', name: 'Volga-Dnepr Airlines', country: 'Russia' },
  { iata: 'VJ', icao: 'RAC', name: 'Royal Air Cambodge', country: 'Cambodia' },
  { iata: 'VK', icao: 'VGN', name: 'Virgin Nigeria Airways', country: 'Nigeria' },
  { iata: 'VL', icao: 'VIM', name: 'Air VIA', country: 'Bulgaria' },
  { iata: 'VN', icao: 'HVN', name: 'Vietnam Airlines', country: 'Vietnam' },
  { iata: 'VO', icao: 'TYR', name: 'Tyrolean Airways', country: 'Austria' },
  { iata: 'VP', icao: 'VSP', name: 'VASP', country: 'Brazil' },
  { iata: 'VQ', icao: 'VKH', name: 'Viking Hellas', country: 'Greece' },
  { iata: 'VR', icao: 'TCV', name: 'TACV', country: 'Portugal' },
  { iata: 'VS', icao: 'VIR', name: 'Virgin Atlantic Airways', country: 'United Kingdom' },
  { iata: 'VT', icao: 'VTA', name: 'Air Tahiti', country: 'French Polynesia' },
  { iata: 'VU', icao: 'VUN', name: 'Air Ivoire', country: 'Ivory Coast' },
  { iata: 'VV', icao: 'AEW', name: 'Aerosvit Airlines', country: 'Ukraine' },
  { iata: 'VW', icao: 'TAO', name: 'Aeromar', country: 'Mexico' },
  { iata: 'VX', icao: 'VRD', name: 'Virgin America', country: 'United States' },
  { iata: 'VY', icao: 'FOS', name: 'Formosa Airlines', country: 'Taiwan' },
  { iata: 'VZ', icao: 'MYT', name: 'MyTravel Airways', country: 'United Kingdom' },
  { iata: 'W1', icao: 'WE1', name: 'World Experience Airline', country: 'Canada' },
  { iata: 'W2', name: 'Maastricht Airlines', country: 'Netherlands' },
  { iata: 'W3', icao: 'WSS', name: 'World Scale Airlines', country: 'United States' },
  { iata: 'W4', icao: 'WER', name: 'AeroWorld', country: 'Russia' },
  { iata: 'W5', icao: 'IRM', name: 'Mahan Air', country: 'Iran' },
  { iata: 'W6', icao: 'WZZ', name: 'Wizz Air', country: 'Hungary' },
  { iata: 'W7', name: 'Austral Brasil', country: 'Brazil' },
  { iata: 'W9', icao: 'JAB', name: 'Air Bagan', country: 'Myanmar' },
  { iata: 'WA', icao: 'KLC', name: 'KLM Cityhopper', country: 'Netherlands' },
  { iata: 'WB', icao: 'RWD', name: 'Rwandair Express', country: 'Rwanda' },
  { iata: 'WC', icao: 'ISV', name: 'Islena De Inversiones', country: 'Honduras' },
  { iata: 'WD', icao: 'AAN', name: 'Amsterdam Airlines', country: 'Netherlands' },
  { iata: 'WE', name: 'Thai Smile Airways', country: 'Thailand' },
  { iata: 'WF', icao: 'WIF', name: 'Widerøe', country: 'Norway' },
  { iata: 'WG', name: 'Sunwing', country: 'Canada' },
  { iata: 'WH', name: 'China Northwest Airlines (WH)', country: 'China' },
  { iata: 'WJ', icao: 'WEB', name: 'WebJet Linhas A', country: 'Brazil' },
  { iata: 'WK', icao: 'EDW', name: 'Edelweiss Air', country: 'Switzerland' },
  { iata: 'WM', name: 'Windward Islands Airways', country: 'Netherlands Antilles' },
  { iata: 'WN', icao: 'SWA', name: 'Southwest Airlines', country: 'United States' },
  { iata: 'WO', icao: 'WOA', name: 'World Airways', country: 'United States' },
  { iata: 'WP', icao: 'MKU', name: 'Island Air (WP)', country: 'United States' },
  { iata: 'WQ', icao: 'PQW', name: 'PanAm World Airways', country: 'United States' },
  { iata: 'WR', icao: 'WEN', name: 'WestJet Encore', country: 'Canada' },
  { iata: 'WS', icao: 'WJA', name: 'WestJet', country: 'Canada' },
  { iata: 'WU', icao: 'WAU', name: 'Wizz Air Ukraine', country: 'Ukraine' },
  { iata: 'WV', icao: 'SWV', name: 'Swe Fly', country: 'Sweden' },
  { iata: 'WW', icao: 'BMI', name: 'bmibaby', country: 'United Kingdom' },
  { iata: 'WX', icao: 'BCY', name: 'CityJet', country: 'Ireland' },
  { iata: 'WY', icao: 'OMA', name: 'Oman Air', country: 'Oman' },
  { iata: 'WZ', icao: 'RWZ', name: 'Red Wings', country: 'Russia' },
  { iata: 'X3', icao: 'HLX', name: 'TUIfly', country: 'Germany' },
  { iata: 'X5', icao: 'OTJ', name: 'Fly Romania', country: 'Romania' },
  { iata: 'XA', icao: 'XAU', name: 'XAIR USA', country: 'United States' },
  { iata: 'XB', icao: 'NXB', name: 'NEXT Brasil', country: 'Brazil' },
  { iata: 'XE', icao: 'BTA', name: 'ExpressJet', country: 'United States' },
  { iata: 'XF', icao: 'VLK', name: 'Vladivostok Air', country: 'Russia' },
  { iata: 'XG', icao: 'CLI', name: 'Calima Aviacion', country: 'Spain' },
  { iata: 'XJ', icao: 'MES', name: 'Mesaba Airlines', country: 'United States' },
  { iata: 'XK', icao: 'CCM', name: 'Corse-Mediterranee', country: 'France' },
  { iata: 'XL', icao: 'LNE', name: 'Aerolane', country: 'Ecuador' },
  { iata: 'XM', icao: 'SMX', name: 'Alitalia Express', country: 'Italy' },
  { iata: 'XN', name: 'Xpressair', country: 'Indonesia' },
  { iata: 'XO', icao: 'LTE', name: 'LTE International Airways', country: 'Spain' },
  { iata: 'XP', icao: 'XPT', name: 'XPTO', country: 'Portugal' },
  { iata: 'XQ', icao: 'SXS', name: 'SunExpress', country: 'Turkey' },
  { iata: 'XR', name: 'Skywest Australia', country: 'Australia' },
  { iata: 'XT', icao: 'AXL', name: 'Air Exel', country: 'Netherlands' },
  { iata: 'XV', name: 'BVI Airways', country: 'British Virgin Islands' },
  { iata: 'XW', icao: 'SXR', name: 'Sky Express', country: 'Russia' },
  { iata: 'XX', icao: 'GFY', name: 'Greenfly', country: 'Spain' },
  { iata: 'XY', icao: 'KNE', name: 'Nas Air', country: 'Saudi Arabia' },
  { iata: 'XZ', name: 'Congo Express', country: 'Congo (Kinshasa)' },
  { iata: 'Y1', name: 'Yellowstone Club Private Shuttle', country: 'United States' },
  { iata: 'Y4', icao: 'VOI', name: 'Volaris', country: 'Mexico' },
  { iata: 'Y5', icao: 'AWA', name: 'Asia Wings', country: 'Kazakhstan' },
  { iata: 'Y7', name: 'NordStar Airlines', country: 'Russia' },
  { iata: 'Y8', icao: 'MRS', name: 'Marusya Airways', country: 'Russia' },
  { iata: 'Y9', icao: 'IRK', name: 'Kish Air', country: 'Iran' },
  { iata: 'YC', icao: 'YCC', name: 'Ciel Canadien', country: 'Canada' },
  { iata: 'YD', name: 'Gomelavia', country: 'Belarus' },
  { iata: 'YE', icao: 'YEL', name: 'Yellowtail', country: 'United States' },
  { iata: 'YH', name: 'Yangon Airways Ltd.', country: 'Burma' },
  { iata: 'YK', name: 'Cyprus Turkish Airlines', country: 'Turkey' },
  { iata: 'YL', icao: 'LLM', name: 'Yamal Airlines', country: 'Russia' },
  { iata: 'YM', icao: 'MGX', name: 'Montenegro Airlines', country: 'Montenegro' },
  { iata: 'YO', icao: 'TYS', name: 'TransHolding System', country: 'Brazil' },
  { iata: 'YQ', name: 'Polet Airlines (Priv)', country: 'Russia' },
  { iata: 'YR', name: 'SENIC AIRLINES', country: 'United States' },
  { iata: 'YS', icao: 'RAE', name: 'Régional', country: 'France' },
  { iata: 'YT', name: 'Yeti Airways', country: 'Nepal' },
  { iata: 'YV', icao: 'ASH', name: 'Mesa Airlines', country: 'United States' },
  { iata: 'YW', icao: 'ANE', name: 'Air Nostrum', country: 'Spain' },
  { iata: 'YX', icao: 'MEP', name: 'Midwest Airlines', country: 'United States' },
  { iata: 'YY', icao: 'VWA', name: 'Virginwings', country: 'Germany' },
  { iata: 'YZ', icao: 'YZZ', name: 'LSM AIRLINES', country: 'Russia' },
  { iata: 'Z0', icao: 'Z9H', name: 'All Argentina Express', country: 'Argentina' },
  { iata: 'Z2', name: 'Zest Air', country: 'Philippines' },
  { iata: 'Z3', icao: 'SMJ', name: 'Avient Aviation', country: 'Zimbabwe' },
  { iata: 'Z4', icao: 'OOM', name: 'Zoom Airlines', country: 'Canada' },
  { iata: 'Z5', icao: 'IIR', name: 'INAVIA Internacional', country: 'Argentina' },
  { iata: 'Z6', icao: 'ZTT', name: 'ZABAIKAL AIRLINES', country: 'Russia' },
  { iata: 'Z7', name: 'REDjet', country: 'Barbados' },
  { iata: 'Z8', icao: 'AZN', name: 'Amaszonas', country: 'Bolivia' },
  { iata: 'Z9', name: 'Flightlink Tanzania', country: 'Tanzania' },
  { iata: 'ZA', icao: 'CYD', name: 'Access Air', country: 'United States' },
  { iata: 'ZB', icao: 'BUB', name: 'Air Bourbon', country: 'Reunion' },
  { iata: 'ZC', icao: 'KGO', name: 'Korongo Airlines', country: 'Congo (Kinshasa)' },
  { iata: 'ZE', icao: 'ESR', name: 'Eastar Jet', country: 'South Korea' },
  { iata: 'ZF', name: 'Athens Airways', country: 'Greece' },
  { iata: 'ZG', icao: 'VVM', name: 'Viva Macau', country: 'Macao' },
  { iata: 'ZH', icao: 'CSZ', name: 'Shenzhen Airlines', country: 'China' },
  { iata: 'ZI', icao: 'AAF', name: 'Aigle Azur', country: 'France' },
  { iata: 'ZJ', name: 'Zambezi Airlines (ZMA)', country: 'Zambia' },
  { iata: 'ZK', icao: 'GLA', name: 'Great Lakes Airlines', country: 'United States' },
  { iata: 'ZL', icao: 'RXA', name: 'Regional Express', country: 'Australia' },
  { iata: 'ZM', icao: 'IWA', name: 'Apache Air', country: 'United States' },
  { iata: 'ZN', icao: 'ZNA', name: 'Zenith International Airline', country: 'Thailand' },
  { iata: 'ZP', icao: 'ZZZ', name: 'Zabaykalskii Airlines', country: 'Russia' },
  { iata: 'ZQ', icao: 'LOC', name: 'Locair', country: 'United States' },
  { iata: 'ZS', icao: 'SMY', name: 'Sama Airlines', country: 'Saudi Arabia' },
  { iata: 'ZT', icao: 'T9P', name: 'Tomp Airlines', country: 'Chile' },
  { iata: 'ZV', icao: 'VAX', name: 'V Air', country: 'Taiwan' },
  { iata: 'ZW', icao: 'AWI', name: 'Air Wisconsin', country: 'United States' },
  { iata: 'ZX', icao: 'ZXY', name: 'Japan Regio', country: 'Japan' },
  { iata: 'ZY', icao: 'ADE', name: 'Ada Air', country: 'Albania' },
  { iata: 'ZZ', name: 'Zz', country: 'Belgium' },
];

const AIRLINES_BY_IATA: ReadonlyMap<string, Airline> = new Map(
  AIRLINES.map((a) => [a.iata, a]),
);

/** Return the airline whose IATA code matches exactly (case-insensitive). */
export function getAirlineByIata(iata: string | null | undefined): Airline | undefined {
  if (!iata) return undefined;
  return AIRLINES_BY_IATA.get(iata.toUpperCase());
}

/** Look up the marketing name for an IATA code, falling back to the code itself. */
export function getAirlineName(iata: string | null | undefined): string {
  if (!iata) return '';
  return getAirlineByIata(iata)?.name ?? iata;
}

// Pre-sorted by name so the empty-query dropdown surfaces recognizable
// carriers ("Aer Lingus", "Aeroflot", ...) instead of whatever happens to
// come first by IATA code.
const AIRLINES_BY_NAME: readonly Airline[] = [...AIRLINES].sort((a, b) =>
  a.name.localeCompare(b.name),
);

/**
 * Typeahead search across IATA code, ICAO, and marketing name (all
 * case-insensitive). Exact IATA matches rank first, then prefix matches on
 * IATA/name, then substring matches. With no query, returns the top N
 * carriers sorted by name.
 */
export function searchAirlines(query: string, limit = 20): Airline[] {
  const q = query.trim().toLowerCase();
  if (!q) return AIRLINES_BY_NAME.slice(0, limit);
  const exact: Airline[] = [];
  const prefix: Airline[] = [];
  const substring: Airline[] = [];
  for (const a of AIRLINES) {
    const iataLc = a.iata.toLowerCase();
    const nameLc = a.name.toLowerCase();
    const icaoLc = a.icao?.toLowerCase();
    if (iataLc === q || icaoLc === q) {
      exact.push(a);
    } else if (iataLc.startsWith(q) || nameLc.startsWith(q)) {
      prefix.push(a);
    } else if (nameLc.includes(q) || (icaoLc && icaoLc.startsWith(q))) {
      substring.push(a);
    }
  }
  return [...exact, ...prefix, ...substring].slice(0, limit);
}
